var React = require('react');

function LoadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.789,6.171a.521.521,0,1,0-1.03.164l0,.009a5.741,5.741,0,1,1-1.426-2.916l-2.31.77a.521.521,0,0,0-.33.659h0a.521.521,0,0,0,.659.33h0l3.129-1.043a.522.522,0,0,0,.357-.495V.521a.521.521,0,0,0-1.043,0v1.9a6.711,6.711,0,1,0,1.992,3.744Z","transform":"translate(-9.461)"}));
}

LoadInline.defaultProps = {"width":"13.422","height":"14","viewBox":"0 0 13.422 14"};

module.exports = LoadInline;

LoadInline.default = LoadInline;
